// Ap: 0,20,40,60....
function start(n: number, pageSize: number) {
  // An A.P starting at 0 with diff 20
  // Nb: 20 = pageSize
  const a0 = 0;
  const d = pageSize;
  const Un = a0 + (n - 1) * d;
  return Un;
}
// Ap: 19,39,59...
export function end(n: number, pageSize: number) {
  // An A.P starting at 19 with diff 20
  // nb: 19= pageSize -1, 20=pageSize
  const a0 = pageSize - 1;
  const d = pageSize;
  const Un = a0 + (n - 1) * d;
  return Un;
}

export function getPage<T>(array: T[], page = 1, pageSize = 20) {
  const endIndex = end(page, pageSize);
  const startIndex = start(page, pageSize);
  const hasMore = endIndex < array.length - 1;
  const totalPages = Math.ceil(array.length / pageSize);
  const slice = array.slice(startIndex, endIndex + 1); // "end" in slice is "endBefore"
  return { slice, hasMore, totalPages };
}
